import React, { Component } from 'react'

export default class Videos extends Component {
  render() {
    let title = ''
    if (this.props.title) {
      title = <h2 className="videos-title">{this.props.title}</h2>
    }
    return (
      <section id="videos" className="videos videos--background">
        {title}
        {this.props.links.map((entry, i) => {
          return <div className="videos-entry" key={'videos' + i}>
            <div className="videos-entry-title" dangerouslySetInnerHTML={{__html:entry.title}}></div>
            <div className="videos-entry-subtitle">{entry.subtitle}</div>
            <div className="intrinsic-container">
              <iframe
                src={
                  'https://www.youtube-nocookie.com/embed/' +
                  entry.url +
                  '?rel=0'
                }
                allowFullScreen
              />
            </div>
          </div>
        })}
      </section>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/videos.js
 **/